import { render, staticRenderFns } from "./RegistAudit.vue?vue&type=template&id=16af6151&scoped=true"
import script from "./RegistAudit.vue?vue&type=script&lang=js"
export * from "./RegistAudit.vue?vue&type=script&lang=js"
import style0 from "./RegistAudit.vue?vue&type=style&index=0&id=16af6151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af6151",
  null
  
)

export default component.exports